export { DMS_MODULE } from '../constants';
export const NAME = 'ProdejOjetychVozu';
export const CRUMB_LABEL_KEY = 'edtPrehledPov';

export const ZALOHA_POV = 'Povzaloha';

export enum PovDruhEnum {
	POV_OTEVRENE = 0,
	POV_UZAVRENE = 1,
	POV_UVOLNENE = 2,
	POV_OPERPREHLED = 3,
	POV_ALL = 4,
	POV_UNDEFINED = 5,
}

export const DEPENDENT_TABLES = <const>[
	ZALOHA_POV,
];

export enum SubStringRezEnum {
	FullString = 0,
	Substring = 1,
	SubstringLeft = 2,
	SubstringRight = 3,
	SubstringRightCorrect = 4,
}

export const TAB_NAMES = <const>{
	ZAKLADNI_INFORMACE: 'ZakladniInformace',
	DOPLNUJICI_INFORMACE: 'DoplnujiciInformace',
	ZALOHY_POV: 'ZalohyPov',
	ZARAZENI: 'Zarazeni',
};
